import styled from '@emotion/styled/macro'
import React, { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as Logo } from '../../assets/logo.svg'
const StyledLogo = styled(Logo)`
    cursor: pointer;
`
function LogoLink(props) {
    // This reference will give us direct access to the mesh
    const navigate = useNavigate()

    return <StyledLogo onClick={() => navigate('/')} {...props} />
}

export default LogoLink
